import { useState, useEffect, useRef } from "react";
import { Modal, Row, Col, message } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import db from "../../../../database";
import { getOAuthHeaders } from "../../../../constants/oAuthValidation";
import styles from "../../../../constants/styles.json";
import { getProductsNearbyStockService, upsertGiftCardTransaction, unlinkTill, upsertEstimate, getEstimates, syncSingleProductByValue } from "../../../../services";
import CWEstimatePrinter from "../../../../lib/printer/CWEstimatePrinter";
import { stock } from "../../../PointOfSale/Core/stock";
import { processSync } from "../../../Sync/syncData";
import useCartStore from "../../../../stores/useCartStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useSessionStore from "../../../../stores/useSessionStore";
import useAuthStore from "../../../../stores/useAuthStore";
import useAdvanceOrderStore from "../../../../stores/useAdvanceOrderStore";
import useTransactionStore from "../../../../stores/useTransactionStore";
import { useWebSocket } from "../../../../lib/components/WebSocketProvider";

const useEstimateHandlers = ({
  tillData,
  cart,
  setCart,
  pricePrecision,
  amount,
  setAmount,
  overPayedAmount,
  giftCardData,
  setGiftCardData,
  handleLoyaltyPayment,
  selectedProductInCart,
  setSelectedProductInCart,
  setStockList,
  setProductSearchInput,
  keyboard,
  setSelectedPaymentMethod,
  setSelectedKeys,
  filterdParkedList,
  showOrderHistory,
  selectedSaleTypeData,
  resetProgress,
  searchHistoryInput,
  searchOrderHistory,
  dateRange,
  onBarcodeInput,
  setCustomerSearchInput,
  form,
  keyboardInputFields,
  setKeyboardInputFields,
  setLayoutName,
  layoutName,
  inputName,
  deleteCart,
  searchInputRef,
  setShowPaymentMethods,
  setOrderHistoryDetails,
  setProductStock,
  setTempCart,
  setShowCompleteSaleStock,
  setCompleteSaleStockData,
  getFilteredPaymentMethods,
  startIndex,
  setShowPayments,
  setStartIndex,
  cardPaymnetStatusPLB,
  setCardPaymnetStatusPLB,
  setOptions,
  productSearchInput,
  deleteProduct,
  setShowCustomMix,
  t,
  setOpenSalesRep,
  setDisplayCustomerSearch,
}) => {
  const [tillLink, setTillLink] = useState(false);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [isLocked, setIsLocked] = useState(false);
  const [isSectionVisible, setIsSectionVisible] = useState(false);
  const [notesPopup, setNotesPopup] = useState(false);
  const [showInputFields, setShowInputFields] = useState(false);
  const [groupName, setGroupName] = useState("Custom Mix");
  const [returnFlag, setReturnFlag] = useState(false);
  const [isPurchaseReturn, setIsPurchaseReturn] = useState(false);
  const [viewStock, setViewStock] = useState(false);
  const [keyValue, setKeyValue] = useState("0");
  const [syncLoad, setSyncLoad] = useState(false);
  const [productItems, setProductItems] = useState([]);
  const [productArray, setProductArray] = useState();
  const [productsDisplay, setProductDisplay] = useState("super-market");
  const estimateNumber = Number(localStorage.getItem("estimateNo") || 1);
  const [estimateNo, setEstimateNo] = useState(estimateNumber);
  const [productsList, setProductsList] = useState([]);
  const [productMap, setProductMap] = useState({});
  const [isEstimatesFlag, setIsEstimatesFlag] = useState(false);
  const [activeEstimatesTab, setActiveEstimatesTab] = useState("pending");
  const [loadingEstimates, setLoadingEstimates] = useState(false);
  const [estimatesData, setEstimatesData] = useState([]);
  const [searchEstimatesInput, setSearchEstimatesInput] = useState("");
  const [expandedEstimatesRowKey, setExpandedEstimatesRowKey] = useState(null);
  const [isSubmittingEstimate, setIsSubmittingEstimate] = useState(false);
  const isAdvanceOrderEnabled = useAdvanceOrderStore((s) => s.isAdvanceOrderEnabled);
  const setIsAdvanceOrderEnabled = useAdvanceOrderStore((s) => s.setIsAdvanceOrderEnabled);

  const productSearchRef = useRef(null);
  const productPanelSearchRef = useRef(null);
  const qtyInputRef = useRef(null);

  const { subscribe } = useWebSocket();

  const { authHeaders } = getOAuthHeaders();
  const redirectUrl = process.env.REACT_APP_redirectURL;
  const posConfig = usePOSConfigStore.getState().posConfig;

  // ——— Effects ———

  useEffect(() => {
    const unsubNew = subscribe("order:new", (payload) => {
      console.debug("[Estimate] New order received:", payload?.orderId);
    });
    const unsubUpdate = subscribe("order:update", (payload) => {
      console.debug("[Estimate] Order updated:", payload?.orderId);
    });
    return () => {
      unsubNew();
      unsubUpdate();
    };
  }, [subscribe]);

  useEffect(() => {
    if (cardPaymnetStatusPLB) {
      Modal.info({
        icon: null,
        okButtonProps: { style: { display: "inline-block" } },
        content: (
          <div
            style={{
              fontSize: "1vw",
              fontWeight: "500",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              paddingLeft: 0,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "58px",
                height: "58px",
                borderRadius: "50%",
                backgroundColor: "rgba(255, 165, 0, 0.2)",
                marginTop: "15px",
              }}
            >
              <ExclamationCircleOutlined style={{ fontSize: "35px", color: "orange" }} />
            </div>
            <p style={{ color: "#0F0718", fontWeight: 550, fontSize: "1.8em", padding: "15px 15px 0 15px", marginBottom: 0 }}>Payment Timed Out</p>
            <p style={{ color: "#0F0718", fontWeight: 400, fontSize: "1.25em", padding: "5px 20px 0 20px" }}>
              Your payment request couldn't be processed in time. Please try again
            </p>
            <button
              style={{ backgroundColor: "#2F3856", color: "#fff", padding: "10px 50px", borderRadius: "10px", border: "none", cursor: "pointer" }}
              onClick={() => {
                setCardPaymnetStatusPLB(false);
                Modal.destroyAll();
              }}
            >
              Try Again
            </button>
          </div>
        ),
        style: { textAlign: "center", height: "50vh", width: "50%" },
        modalRender: (modal) => <div style={{ borderRadius: "12px", overflow: "hidden" }}>{modal}</div>,
        bodyStyle: { padding: "0" },
        closable: false,
        onOk: null,
      });
    }
  }, [cardPaymnetStatusPLB]);

  useEffect(() => {
    setTimeout(() => {
      try {
        const cartDetails = useCartStore.getState().cart;
        if (cartDetails !== null) setCart(cartDetails);
      } catch (error) {
        console.error("Error parsing cart details:", error);
      }
    }, 200);
    setTimeout(() => {
      setProductSearchInput("");
      const el = document.getElementById("sm-product-search");
      if (el) el.blur();
      keyboard?.current?.setInput("");
    }, 200);
  }, []);

  useEffect(() => {
    if (!selectedProductInCart || !selectedProductInCart.productId) return;
    const stillExists = cart.items.some((item) => item.productId === selectedProductInCart.productId);
    if (!stillExists) {
      if (cart.items.length > 0) {
        setSelectedProductInCart(cart.items[cart.items.length - 1]);
      } else {
        setSelectedProductInCart({});
        setStockList([]);
      }
    }
  }, [cart.items]);

  useEffect(() => {
    if (cart.items.length === 0 && cart.payments.length > 0) {
      cart.payments.forEach((payment) => {
        handleDeletePayment(payment);
      });
    }
  }, [cart]);

  useEffect(() => {
    if (isEstimatesFlag) fetchEstimates("PE");
  }, [isEstimatesFlag]);

  // ——— Keyboard handlers ———

  const updateKeyboardInputs = async (inputs) => {
    if (!inputs) return;
    if (inputName === "customerSearch") setCustomerSearchInput(inputs?.customerSearch || "");
    if (inputName === "productSearch") {
      const searchValue = inputs?.productSearch || inputs?.productSearch1 || "";
      setProductSearchInput(searchValue);
      await handleSearch(searchValue);
    }
    if (inputName === "productSearch1") setProductSearchInput(inputs?.productSearch1 || "");
    if (keyboardInputFields?.type === "addCustomerForm" || keyboardInputFields?.type === "editCustomerForm" || keyboardInputFields?.type === "UAECustomerForm") {
      const customerObj = form?.getFieldsValue(true) || {};
      const updatedFields = { ...customerObj, ...inputs };
      setKeyboardInputFields(updatedFields);
      form?.setFieldsValue(updatedFields);
    }
  };

  const onKeyPress = (button) => {
    const el = document.getElementById("sm-product-search");
    if (button === "{enter}") {
      setLayoutName("default");
      switch (inputName !== "") {
        case inputName === "salesHistoryInput":
          if (searchHistoryInput !== "") searchOrderHistory("customer", searchHistoryInput, 0, dateRange?.length > 0);
          break;
        case inputName === "productSearch":
          onBarcodeInput(el.value, true);
          break;
        case inputName === "productSearch1":
          handleSelectProduct();
        default:
          break;
      }
    } else if (button === "{number}") setLayoutName("number");
    else if (button === "{numbers}") setLayoutName("numbers");
    else if (button === "{caps}") setLayoutName("default");
    else if (button === "{small}") setLayoutName("shift");
    else if (button === "{shift}" || button === "{lock}") {
      setLayoutName(layoutName === "default" ? "shift" : "default");
    }
  };

  // ——— Utility handlers ———

  const errorMessage = (modalTitle, modalContent) => {
    Modal.error({ title: modalTitle, content: modalContent });
  };

  const handleCancel = () => {
    Modal.destroyAll();
    const el = document.getElementById("sm-product-search");
    if (el) setTimeout(() => el.focus(), 300);
  };

  const showPreviousItems = () => {};

  const modulo = (a, b) => a - b * Math.floor(a / b);

  const removeProductModal = (record) => {
    setShowCustomMix(false);
    deleteProduct(record);
  };

  // ——— Product search ———

  const handleSelectProduct = async () => {
    await db.products
      .filter((product) => product.isactive == true)
      .filter((product) => product.productSegment !== "BG")
      .toArray()
      .then((productsFetched) => {
        const lowerCaseSearchInput = productSearchInput.toLowerCase();
        const filteredProducts = productsFetched.filter(
          (product) =>
            product?.name?.toLowerCase().includes(lowerCaseSearchInput) ||
            product?.batchIndex === lowerCaseSearchInput ||
            product?.upcIndex === lowerCaseSearchInput ||
            product?.value === lowerCaseSearchInput ||
            product?.upc === lowerCaseSearchInput
        );
        if (filteredProducts.length === 0) {
          message.info(`${t("product_search_category_error")}`);
        } else {
          setProductsList(filteredProducts);
        }
      });
  };

  const handleSearch = async (data) => {
    if (!data) {
      setOptions([]);
      setProductMap({});
      return;
    }
    let products = await db.products.search({
      searchTerm: data,
      isSmartSearch: posConfig?.is_smart_product_search === "Y",
      limit: 20,
    });

    // Cache miss → try on-demand single-product sync once (roadmap ad6b7339).
    if (products.length === 0 && String(data).trim().length >= 2 && tillData?.tillAccess?.csBunit?.csBunitId) {
      try {
        const synced = await syncSingleProductByValue(tillData, uuidv4(), tillData?.tillAccess?.cwrTill?.cwrTillID, String(data).trim());
        if (synced) {
          products = await db.products.search({
            searchTerm: data,
            isSmartSearch: posConfig?.is_smart_product_search === "Y",
            limit: 20,
          });
        }
      } catch (err) {
        console.warn("[Estimate] single-product sync failed:", err?.message);
      }
    }

    if (products.length > 0) {
      const filteredOptions = products.map((item) => ({ label: `${item.value} - ${item.name}`, value: item.value }));
      const map = {};
      products.forEach((item) => {
        map[item.value] = item;
      });
      setOptions(filteredOptions);
      setProductMap(map);
    } else {
      setOptions([]);
      setProductMap({});
    }
  };

  const onChangeInput = async (event) => {
    const inputVal = event.target.value;
    setProductSearchInput(inputVal);
    localStorage.setItem("productName", inputVal);
    keyboard?.current?.setInput(inputVal);
    if (posConfig?.product_search_display_mode === "dropdown") {
      if (inputVal.trim() === "") {
        setOptions([]);
        setProductMap({});
        return;
      }
      await handleSearch(inputVal);
    }
  };

  // ——— Estimates ———

  const fetchEstimates = async (status) => {
    setLoadingEstimates(true);
    try {
      const bunitId = tillData?.tillAccess?.csBunit?.csBunitId;
      const currentDate = dayjs().format("YYYY-MM-DD");
      const response = await getEstimates({
        bunitId,
        recordId: "",
        status,
        startRow: "0",
        endRow: "2000",
        date: currentDate,
        documentno: searchEstimatesInput,
      });
      if (response?.status === 200) {
        const data = JSON.parse(response?.data?.data?.getEstimates || "[]");
        const transformedData = data?.estimates?.map((item, index) => ({ ...item, key: item.s_estimate_id || `${index}` }));
        setEstimatesData(transformedData);
      } else {
        message.warning("Something is wrong in get estimates service");
      }
    } catch (error) {
      console.error("Error fetching estimates:", error);
    } finally {
      setLoadingEstimates(false);
    }
  };

  const handleUpsertEstimate = async (status) => {
    if (isSubmittingEstimate) return;
    const estimateJson = useCartStore.getState().cart || {};
    if (posConfig?.requireSalesRepresentative === "Y") {
      if (estimateJson?.salesRepId === null) {
        setOpenSalesRep({ flag: true, level: "order" });
        return false;
      }
    }
    const defaultCustomer = tillData?.tillAccess?.csBunit?.b2cCustomer;
    if (isAdvanceOrderEnabled && defaultCustomer?.cwrCustomerId === estimateJson?.customer?.cwrCustomerId && estimateJson?.total > 0) {
      message.warning("Please select a customer for Advance Order.");
      if (setDisplayCustomerSearch) setDisplayCustomerSearch(true);
      return false;
    }
    if (estimateJson?.items?.length > 0) {
      setIsSubmittingEstimate(true);
      try {
        const bunitId = tillData?.tillAccess?.csBunit?.csBunitId;
        const estimateId = estimateJson?.estimateId ? estimateJson?.estimateId : uuidv4().replace(/-/g, "").toUpperCase();
        const date = dayjs().format("YYYY-MM-DD HH:mm:ss");
        const isAdvanceOrder = isAdvanceOrderEnabled ? "Y" : "N";
        const response = await upsertEstimate({ bunitId, estimateId, date, status: status === "HOLD" ? "PE" : status, isAdvanceOrder, estimateJson });
        if (response?.status === 200) {
          if (response?.data?.data?.upsertEstimate?.status === "200") {
            message.success(response?.data?.data?.upsertEstimate?.message);
            const documentNo = response?.data?.data?.upsertEstimate?.message?.split(": ")[1] || "";
            if (status === "PE") await CWEstimatePrinter(cart, estimateId, documentNo);
            deleteCart();
            setIsAdvanceOrderEnabled(false);
            setEstimateNo((prev) => {
              const next = prev + 1;
              localStorage.setItem("estimateNo", next);
              return next;
            });
            localStorage.removeItem("isB2bEnabled");
            useTransactionStore.getState().setIsB2bEnabled(null);
            localStorage.removeItem("customerAddressIds");
            if (searchInputRef?.current) searchInputRef.current.focus();
          } else if (response?.data?.data?.upsertEstimate?.status === "201") {
            Modal.warning({
              title: "Estimate Already Processed",
              content: "This estimate has already been cancelled or has not been modified since it was last saved. Do you want to proceed and clear the current transaction?",
              okText: "Proceed",
              cancelButtonProps: {
                style: { display: "none" },
              },
              onOk: () => {
                deleteCart();
                setIsAdvanceOrderEnabled(false);
                setEstimateNo((prev) => {
                  const next = prev + 1;
                  localStorage.setItem("estimateNo", next);
                  return next;
                });
                localStorage.removeItem("isB2bEnabled");
                useTransactionStore.getState().setIsB2bEnabled(null);
                localStorage.removeItem("customerAddressIds");
                if (searchInputRef?.current) {
                  searchInputRef.current.focus();
                }
              },
            });
          } else {
            message.error("Something is wrong in upsertEstimate service");
          }
        } else {
          message.warning("Something is wrong in upsertEstimate service");
        }
      } finally {
        setIsSubmittingEstimate(false);
      }
    }
  };

  const handleRetrieveEstimate = async (record) => {
    console.debug("[v0] Retrieving estimate record:", record);
    const cartData = JSON.parse(record.estimate_json || "{}");
    cartData.estimateId = record?.s_estimate_id;
    cartData.isAdvanceOrder = record?.is_advanceorder || "N";
    setIsAdvanceOrderEnabled(record?.is_advanceorder === "Y");
    let stockCheckResult = true;
    let isFinalValidation = false;
    if (navigator.onLine && tillData?.tillAccess?.csBunit?.allowNegativeStock !== "Y") {
      stockCheckResult = await stock({
        cart: cartData,
        setCart,
        tillData,
        setProductStock,
        isFinalValidation,
        setTempCart,
        isCompleteSale: true,
        setShowCompleteSaleStock,
        setCompleteSaleStockData,
      });
      if (!stockCheckResult) {
        setSelectedProductInCart({});
        return;
      } else {
        setOrderHistoryDetails([]);
        setIsEstimatesFlag(false);
      }
    } else {
      setOrderHistoryDetails([]);
      setIsEstimatesFlag(false);
    }
    if (cartData?.customer?.isB2bEnabled === "Y") {
      localStorage.setItem("isB2bEnabled", "true");
      useTransactionStore.getState().setIsB2bEnabled("true");
    }
    if (cartData?.customer?.customerAddressIds) {
      localStorage.setItem("customerAddressIds", JSON.stringify(cartData.customer.customerAddressIds));
    }
    setCart(cartData);
    setEstimatesData([]);
    setExpandedEstimatesRowKey(null);
    setSearchEstimatesInput("");
  };

  // ——— Payments ———

  const handleDeletePayment = (payment) => {
    let paid = 0;
    Promise.all(
      cart.payments.map(async (pay) => {
        if (payment.name.toLowerCase() === "gift card" && payment.finPaymentmethodId === pay.finPaymentmethodId) {
          const upsertDetails = giftCardData.map((ele) => ({
            cardNo: ele.number || null,
            type: "RD",
            referenceNo: cart.referenceId,
            amount: ele.amount * -1,
            cardPin: ele.pin || null,
          }));
          const upsertDetailsStrings = upsertDetails.map(
            (d) => `{
            cardNo: ${d.cardNo ? `"${d.cardNo}"` : null}, type: "${d.type}",
            referenceNo: "${d.referenceNo}", amount: ${d.amount},
            cardPin: ${d.cardPin ? `"${d.cardPin}"` : null}
            tillId: ${tillData?.tillAccess?.cwrTill?.cwrTillID ? `"${tillData?.tillAccess?.cwrTill?.cwrTillID}"` : null}
            b2c_Customer_Id: ${cart.customer.cwrCustomerId ? `"${cart.customer.cwrCustomerId}"` : null}
          }`
          );
          const data = { query: `mutation { upsertGiftCardTransaction(giftCardTransactions: [${upsertDetailsStrings}]) { status message } }` };
          const response = await upsertGiftCardTransaction(data);
          let cardDetails = [...giftCardData];
          let uniqId = uuidv4().replace(/-/g, "").toUpperCase();
          if (response.data.data.upsertGiftCardTransaction.status == 200) {
            upsertDetails.forEach((detail) => {
              cardDetails.push({ number: detail.cardNo, amount: detail.amount, redemptionId: uniqId, pin: detail.cardPin || null });
            });
          }
          setGiftCardData(cardDetails);
        } else if (payment.name.toLowerCase() === "loyalty" && payment.finPaymentmethodId === pay.finPaymentmethodId) {
          await handleLoyaltyPayment(payment, cart);
        } else if (pay.name !== payment.name && payment.name.toLowerCase() !== "card") {
          paid += parseFloat(pay.amount);
          return pay;
        } else if (payment.name.toLowerCase() === "card" && (payment.authorization ? pay.authorization !== payment.authorization : true)) {
          paid += parseFloat(pay.amount);
          return pay;
        }
      })
    )
      .then((results) => {
        cart.payments = results.filter((r) => r !== undefined);
        cart.paid = paid + (cart?.advancePayment || 0);
        setAmount(parseFloat((cart.total - cart.paid).toFixed(pricePrecision)));
        if (payment?.name?.toLowerCase() === "cash") cart.tenderedAmount = cart.tenderedAmount - payment.amount;
        setCart(cart);
      })
      .catch(console.error);
  };

  const handleKeyvalue = async (key) => {
    if (key === "0") {
      setSelectedPaymentMethod({});
      setKeyValue("0");
      setSelectedKeys([]);
    }
    if (key === "1") {
      filterdParkedList?.map((item) => {
        item.status = "Parked";
        item.key = uuidv4().replace(/-/g, "").toUpperCase();
        item.customer = item.parkedCart.customer.name;
        item.qty = item.parkedCart.totalQty;
      });
      setKeyValue("1");
      setSelectedKeys([]);
    }
    if (key === "2") {
      setKeyValue("2");
      setSelectedKeys([]);
    }
    if (key === "3") {
      showOrderHistory();
      setKeyValue("3");
      setSelectedKeys([]);
    }
    if (key === "4") {
      setSyncLoad(true);
      let tillDataLocal = useAuthStore.getState().tillData;
      const defaultCustomer = selectedSaleTypeData?.customer?.b2cCustomerId ? selectedSaleTypeData?.customer : tillDataLocal.tillAccess.csBunit.b2cCustomer;
      setCart({ ...cart, customer: defaultCustomer });
      await processSync(tillDataLocal, "Incremental Sync");
      setSyncLoad(false);
      resetProgress();
    }
    if (key === "7") {
      setKeyValue("7");
      setSelectedKeys([]);
    }
    if (key === "parked-bill") {
      filterdParkedList?.map((item) => {
        item.status = "Parked";
        item.key = uuidv4().replace(/-/g, "").toUpperCase();
        item.customer = item.parkedCart.customer.name;
        item.qty = item.parkedCart.totalQty;
      });
    }
  };

  const showConfirm = () => {
    return new Promise((resolve) => {
      Modal.confirm({
        title: (
          <>
            <ExclamationCircleOutlined style={{ color: "#FAAD17" }} /> Confirm Payment Details
          </>
        ),
        icon: null,
        content: (
          <div
            style={{
              background: "#fff",
              height: "auto",
              width: "100%",
              border: "1px solid #fff",
              borderRadius: "7px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Row style={{ fontSize: "1em", width: "100%" }}>
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Bill Amount</p>
              </Col>
              <Col span={12} style={{ display: "flex", alignItems: "center", textAlign: "right", justifyContent: "end" }}>
                <p style={{ textAlign: "right", fontWeight: "400", color: "#0F0718" }}>{parseFloat(Math.abs(cart.total)).toFixed(pricePrecision)}</p>
              </Col>
            </Row>
            <Row style={{ fontSize: "1em", width: "100%" }}>
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Amount Tendered</p>
              </Col>
              <Col span={12} style={{ display: "flex", alignItems: "center", textAlign: "right", justifyContent: "end" }}>
                <p style={{ textAlign: "right", fontWeight: "400", color: "#0F0718" }}>{parseFloat(amount || 0).toFixed(pricePrecision)}</p>
              </Col>
            </Row>
            <Row style={{ fontSize: "1em", width: "100%" }}>
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Amount Received</p>
              </Col>
              <Col span={12} style={{ display: "flex", alignItems: "center", textAlign: "right", justifyContent: "end" }}>
                <p style={{ textAlign: "right", fontWeight: "400", color: "#0F0718" }}>{Math.abs(cart.total - cart.paid).toFixed(pricePrecision)}</p>
              </Col>
            </Row>
            <Row style={{ fontSize: "1em", width: "100%" }}>
              <Col span={12} style={styles.screenStyles.mainScreen.paymentsData}>
                <p>Change Due</p>
              </Col>
              <Col span={12} style={{ display: "flex", alignItems: "center", textAlign: "right", justifyContent: "end" }}>
                <p style={{ textAlign: "right", fontWeight: "400", color: "#0F0718" }}>
                  {cart.paid + parseFloat(amount || 0) - Math.abs(cart.total) > 0
                    ? (cart.paid + parseFloat(amount || 0) - Math.abs(Math.abs(cart.total) + Math.abs(overPayedAmount))).toFixed(pricePrecision)
                    : cart?.change <= 0
                      ? "0.00"
                      : cart?.change}
                </p>
              </Col>
            </Row>
          </div>
        ),
        onOk() {
          resolve(true);
        },
        onCancel() {
          resolve(false);
        },
        cancelButtonProps: { style: { borderRadius: "5px" } },
        okButtonProps: { style: { borderRadius: "5px" } },
      });
    });
  };

  const showMoreItems = () => {
    const PaymentMethods = tillData.tillAccess.csBunit.paymentMethodList;
    let paymentDetails = getFilteredPaymentMethods();
    if (
      cart?.docType === "Advance" &&
      posConfig?.allowLayawaywithoutPayment !== "Y" &&
      !cart.items.some((item) => item.type === "S" && item?.productSegment === "AD" && item.weight > 0)
    ) {
      paymentDetails = [
        ...paymentDetails,
        {
          cWRPaymentMethodID: "",
          sequenceNo: 9999,
          finPaymentmethodId: "",
          finFinancialAccountId: "",
          finDayCloseAccountId: null,
          name: "Complete Order",
          integratedPayment: false,
          isloyalty: false,
          paymentProvider: null,
          iscredit: false,
          isGiftCard: false,
          isDefault: "N",
          csCurrencyId: "",
          isoCode: "AED",
          isactive: true,
          salesType: [],
        },
      ];
    }
    let itemsPerPage =
      tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId === cart?.customer?.cwrCustomerId && PaymentMethods.length === 5 ? 5 : cart.layAway === "Y" ? 4 : 5;
    if (startIndex + itemsPerPage >= paymentDetails.length) {
      if (startIndex < paymentDetails.length) {
        setShowPayments(paymentDetails.slice(startIndex, paymentDetails.length));
        setStartIndex(paymentDetails.length);
      } else {
        setShowPayments(paymentDetails.slice(0, itemsPerPage));
        setStartIndex(itemsPerPage);
      }
    } else {
      setShowPayments(paymentDetails.slice(startIndex, itemsPerPage + startIndex));
      setStartIndex(startIndex + itemsPerPage);
    }
  };

  // ——— Till ———

  const confirmUnlink = () => {
    Modal.confirm({
      title: "Confirm Unlink",
      content: "Are you sure you want to unlink the till?",
      okText: "Yes",
      cancelText: "Cancel",
      okButtonProps: { style: { display: "inline-block" } },
      onOk: async () => {
        await tillUnlink();
      },
      onCancel: () => {
        console.debug("Unlink operation cancelled");
      },
    });
  };

  const tillUnlink = async () => {
    try {
      let id = tillData.tillAccess.cwrTill.cwrTillID;
      const response = await unlinkTill(id);
      if (response.data.data.unlinkTill.status === "200") {
        localStorage.clear();
        await Promise.all(
          db.tables.map(async (table) => {
            await table.clear();
          })
        );
      }
      document.cookie.split(";").forEach((cookie) => {
        document.cookie = cookie.replace(/^ +/, "").replace(/=.*/, `=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`);
      });
      useSessionStore.getState().setUnlink(false);
      window.location.assign(`${redirectUrl}sign-in`);
    } catch (error) {
      console.error("Error in unlinkTillAPI:", error);
    }
  };

  // ——— Stock ———

  const getProductNearByStock = async () => {
    try {
      const stockInputValues = {
        query: `query { getProductsNearbyStock(bUnitId: "${tillData.tillAccess.csBunit.csBunitId}", code: "${selectedProductInCart.value}") { csBunitId value name totalQty stores { csNearbyStoreId name nearbybUnitId viewStock isIssue warehouse { mWarehouseID name value storageBin { mStoragebinID name stocks { mStockID qtyonhand product { mProductId value name upc uom { csUomId name } productCategory { mProductCategoryId value name } } batch { mBatchId batchno upc price startdate enddate life purchasePrice listPrice purchaseDate } } totalQty } } } } }`,
      };
      const response = await getProductsNearbyStockService(stockInputValues);
      const { stores, totalQty, csBunitId } = response.data.data.getProductsNearbyStock;
      const currentStock = {
        csNearbyStoreId: "53F4FBEBDAB94C4AB205B7415EBD739E",
        name: tillData.tillAccess.csBunit.mWarehouse.name,
        nearbybUnitId: "EEF9FADCE0D74AE3B8B6096E6C35B6AA",
        viewStock: "Y",
        isIssue: "Y",
        warehouse: {
          mWarehouseID: "79FD0E516E4F4C5F9A7932F0C5C82C92",
          name: tillData.tillAccess.csBunit.mWarehouse.name,
          value: "Central WH TTLLC",
          storageBin: { mStoragebinID: "09581CA09C154830A20B88370C501FD6", name: "Central Warehouse", stocks: [], totalQty: totalQty || 0 },
        },
      };
      const isStorePresent = stores?.some((store) => store?.nearbybUnitId === csBunitId);
      setStockList(isStorePresent ? stores : [currentStock, ...stores]);
    } catch (error) {
      console.error("Error fetching nearby stock:", error);
    }
  };

  const handleViewStockClick = () => {
    getProductNearByStock();
    setViewStock(true);
  };

  return {
    // State
    tillLink,
    setTillLink,
    isOnline,
    isLocked,
    setIsLocked,
    isSectionVisible,
    notesPopup,
    setNotesPopup,
    showInputFields,
    setShowInputFields,
    groupName,
    setGroupName,
    returnFlag,
    setReturnFlag,
    isPurchaseReturn,
    setIsPurchaseReturn,
    viewStock,
    keyValue,
    setKeyValue,
    syncLoad,
    setSyncLoad,
    productItems,
    setProductItems,
    productArray,
    setProductArray,
    productsDisplay,
    estimateNo,
    setEstimateNo,
    productsList,
    setProductsList,
    productMap,
    setProductMap,
    isEstimatesFlag,
    setIsEstimatesFlag,
    activeEstimatesTab,
    setActiveEstimatesTab,
    loadingEstimates,
    estimatesData,
    searchEstimatesInput,
    setSearchEstimatesInput,
    expandedEstimatesRowKey,
    setExpandedEstimatesRowKey,
    isAdvanceOrderEnabled,
    setIsAdvanceOrderEnabled,
    isSubmittingEstimate,
    productSearchRef,
    productPanelSearchRef,
    qtyInputRef,
    // Handlers
    errorMessage,
    handleCancel,
    showPreviousItems,
    modulo,
    removeProductModal,
    updateKeyboardInputs,
    onKeyPress,
    handleSelectProduct,
    handleSearch,
    onChangeInput,
    fetchEstimates,
    handleUpsertEstimate,
    handleRetrieveEstimate,
    handleDeletePayment,
    handleKeyvalue,
    showConfirm,
    showMoreItems,
    confirmUnlink,
    handleViewStockClick,
  };
};

export default useEstimateHandlers;
